import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ApiService } from './../shared/api.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TweenMax } from "gsap";
import { BeneficioClientesVulnerablesCovid19 } from '../shared/beneficio-clientes-vulnerables-covid19';
import { UploaderService } from "../shared/uploader.service";
import { DeleterService } from "../shared/deleter.service";
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { RutService } from '../shared/rut.service';
import { ValidatorService } from '../shared/validator-service.service';
import { rutValidator, numClienteValidator } from '../shared/validator-service.service';
import { requiredFileType } from '../shared/requiredFileType.service';
import { GlobalConstants } from '../shared/global-constants';
import { TextosCovid19 } from '../shared/textos-covid19';
import { NgxSpinnerService } from "ngx-spinner";
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';
import { ModalPoliticaPrivacidadComponent } from '../modales/modal-politica-privacidad/modal-politica-privacidad.component';

@Component({
  selector: 'app-beneficio-clientes-vulnerables-covid19',
  templateUrl: './beneficio-clientes-vulnerables-covid19.component.html',
  styleUrls: ['./beneficio-clientes-vulnerables-covid19.component.scss']
})
export class BeneficioClientesVulnerablesCovid19Component implements OnInit {
  fileRutSol: File = null;//OK 1
  fileRutSolReverso: File = null;//OK 1
  fileRegistroSocialHogares: File = null;//OK 2
  fileAcreditacionResidencia: File = null; //OK 3
  fileActivacionSeguroCesantia: File = null;//OK 4
  fileAnexoContrato: File = null;//OK 5
  //fileCertificadoTrabajadorIndependiente: File = null;//6 OK trabajador independiente
  //fileImposibilidadPago: File = null;//7 CORRESPONDÍA A OTROS (SACAR)
  //fileSituacionVulnerabilidad: File = null;//8 CORRESPONDÍA A OTROS (SACAR)
  fileFiniquitoCartaDespido: File = null;//OK 9
  fileDeclaracionJuradaSimple: File = null; //NUEVO OK 10
  fileExposicionFundadaSolicitud: File = null; //NUEVO OK 11
  filePersoneria: File = null; //NUEVO 12

  formData: FormGroup;
  submitted = false;
  pasos: any;
  perfil: string;

  public textosCovid19 = TextosCovid19;
  public mimeTypes = ValidatorService.mimeTypes;
  public dataComuna: Array<any>;
  public dataRegion: Array<any>;
  public dataCuotas: Array<any>;
  public dataDirecciones: Array<any>;
  public dataTipoInstitucion: Array<any>;

  public total_solicitudes: any;
  public total_solicitudes_rm: any;
  public total_solicitudes_ohi: any;
  public total_solicitudes_lla: any;
  public porc_total_solicitudes_rm: any;
  public porc_total_solicitudes_ohi: any;
  public porc_total_solicitudes_lla: any;
  public solicitudes_aprobadas: any;
  public solicitudes_pendientes_aprobacion: any;
  public solicitudes_rechazadas: any;
  public solicitudes_desistidas: any;
  public porc_solicitudes_aprobadas: any;
  public porc_solicitudes_pendientes_aprobacion: any;
  public porc_solicitudes_rechazadas: any;
  public porc_solicitudes_desistidas: any;
  public solicitudes_aprobadas_rm: any;
  public solicitudes_pendientes_aprobacion_rm: any;
  public solicitudes_rechazadas_rm: any;
  public solicitudes_desistidas_rm: any;
  public porc_solicitudes_aprobadas_rm: any;
  public porc_solicitudes_pendientes_aprobacion_rm: any;
  public porc_solicitudes_rechazadas_rm: any;
  public porc_solicitudes_desistidas_rm: any;
  public solicitudes_aprobadas_ohi: any;
  public solicitudes_pendientes_aprobacion_ohi: any;
  public solicitudes_rechazadas_ohi: any;
  public solicitudes_desistidas_ohi: any;
  public porc_solicitudes_aprobadas_ohi: any;
  public porc_solicitudes_pendientes_aprobacion_ohi: any;
  public porc_solicitudes_rechazadas_ohi: any;
  public porc_solicitudes_desistidas_ohi: any;
  public solicitudes_aprobadas_lla: any;
  public solicitudes_pendientes_aprobacion_lla: any;
  public solicitudes_rechazadas_lla: any;
  public solicitudes_desistidas_lla: any;
  public porc_solicitudes_aprobadas_lla: any;
  public porc_solicitudes_pendientes_aprobacion_lla: any;
  public porc_solicitudes_rechazadas_lla: any;
  public porc_solicitudes_desistidas_lla: any;
  public tasa_aprobacion: any;
  public tasa_aprobacion_rm: any;
  public tasa_aprobacion_ohi: any;
  public tasa_aprobacion_lla: any;
  public fechaSolicitud: any;

  @ViewChild('comunaOk') comunaOk;

  infoMessageRutSol: any;
  infoMessageRutSolReverso: any;
  infoMessageRegistroSocialHogares: any;
  infoMessageAcreditacionResidencia: any;
  infoMessageActivacionSeguroCesantia: any;
  infoMessageAnexoContrato: any;
  //infoMessageCertificadoTrabajadorIndependiente: any;
  //infoMessageImposibilidadPago: any;
  //infoMessageSituacionVulnerabilidad: any;
  infoMessageFiniquitoCartaDespido: any;
  infoMessageDeclaracionJuradaSimple: any;
  infoMessageExposicionFundadaSolicitud: any;
  infoMessagePersoneria: any;

  tokenMessageRutSol: any;
  tokenMessageRutSolReverso: any;
  tokenMessageRegistroSocialHogares: any;
  tokenMessageAcreditacionResidencia: any;
  tokenMessageActivacionSeguroCesantia: any;
  tokenMessageAnexoContrato: any;
  //tokenMessageCertificadoTrabajadorIndependiente: any;
  //tokenMessageImposibilidadPago: any;
  //tokenMessageSituacionVulnerabilidad: any;
  tokenMessageFiniquitoCartaDespido: any;
  tokenMessageDeclaracionJuradaSimple: any;
  tokenMessageExposicionFundadaSolicitud: any;
  tokenMessagePersoneria: any;

  errorInfoMessageRutSol: any;
  errorInfoMessageRutSolReverso: any;
  errorInfoMessageRegistroSocialHogares: any;
  errorInfoMessageAcreditacionResidencia: any;
  errorInfoMessageActivacionSeguroCesantia: any;
  errorInfoMessageAnexoContrato: any;
  //errorInfoMessageCertificadoTrabajadorIndependiente: any;
  //errorInfoMessageImposibilidadPago: any;
  //errorInfoMessageSituacionVulnerabilidad: any;
  errorInfoMessageFiniquitoCartaDespido: any;
  errorInfoMessageDeclaracionJuradaSimple: any;
  errorInfoMessageExposicionFundadaSolicitud: any;
  errorInfoMessagePersoneria: any;

  file: File;
  fileNameRutSol: string = "";
  fileNameRutSolReverso: string = "";
  fileNameRegistroSocialHogares: string = "";
  fileNameAcreditacionResidencia: string = "";
  fileNameActivacionSeguroCesantia: string = "";
  fileNameAnexoContrato: string = "";
  //fileNameCertificadoTrabajadorIndependiente: string = "";
  //fileNameImposibilidadPago: string = "";
  //fileNameSituacionVulnerabilidad: string = "";
  fileNameFiniquitoCartaDespido: string = "";
  fileNameDeclaracionJuradaSimple: string = "";
  fileNameExposicionFundadaSolicitud: string = "";
  fileNamePersoneria: string = "";

  extensionRutSol: string = "";
  extensionRutSolReverso: string = "";
  extensionRegistroSocialHogares: string = "";
  extensionAcreditacionResidencia: string = "";
  extensionActivacionSeguroCesantia: string = "";
  extensionAnexoContrato: string = "";
  //extensionCertificadoTrabajadorIndependiente: string = "";
  //extensionImposibilidadPago: string = "";
  //extensionSituacionVulnerabilidad: string = "";
  extensionFiniquitoCartaDespido: string = "";
  extensionDeclaracionJuradaSimple: string = "";
  extensionExposicionFundadaSolicitud: string = "";
  extensionPersoneria: string = "";

  imageUrlRutSol: string | ArrayBuffer = "";
  imageUrlRutSolReverso: string | ArrayBuffer = "";
  imageUrlRegistroSocialHogares: string | ArrayBuffer = "";
  imageUrlAcreditacionResidencia: string | ArrayBuffer = "";
  imageUrlActivacionSeguroCesantia: string | ArrayBuffer = "";
  imageUrlAnexoContrato: string | ArrayBuffer = "";
  //imageUrlCertificadoTrabajadorIndependiente: string | ArrayBuffer = "";
  //imageUrlImposibilidadPago: string | ArrayBuffer = "";
  //imageUrlSituacionVulnerabilidad: string | ArrayBuffer = "";
  imageUrlFiniquitoCartaDespido: string | ArrayBuffer = "";
  imageUrlDeclaracionJuradaSimple: string | ArrayBuffer = "";
  imageUrlExposicionFundadaSolicitud: string | ArrayBuffer = "";
  imageUrlPersoneria: string | ArrayBuffer = "";

  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private uploader: UploaderService,
    private deleter: DeleterService,
    private rutService: RutService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private dialog: MatDialog,

  ) {
    // PASOS DE LA VISTA
    this.pasos = [{
      "P1": {
        //*DevFun* Init
        "I": true,
        "CurrentNum": true
      },
      "P2": {
        "I": false,
        "CurrentNum": false
      },
      "P3": {
        "I": false,
        "CurrentNum": false
      },
      "P4": {
        "I": false,
        "CurrentNum": false
      }
    }]
  }

  ngOnInit() {
    // CONTROLS FORMULARIO PASO 2
    this.formData = this.formBuilder.group({
      tipoInstitucion: [null, []],
      nombre: ['', [Validators.required, Validators.pattern(ValidatorService.nombre)]],
      rut: ['', [Validators.minLength(3), Validators.maxLength(12), Validators.required, rutValidator]],
      telefono: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.telefono)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      nCliente: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator]],
      direccion: ['', [Validators.required, Validators.pattern(ValidatorService.direccion)]],
      comuna: [null, [Validators.required]],
      region: [null, [Validators.required]],
      detalleSituacion: ['', [Validators.maxLength(600), Validators.pattern(ValidatorService.detalleSituacion)]],
      numeroCuotas: ['', [Validators.required, Validators.min(1), Validators.max(48)]],
      fileRutSol: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileRutSolReverso: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileRegistroSocialHogares: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileAcreditacionResidencia: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileActivacionSeguroCesantia: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileAnexoContrato: ['', [requiredFileType(ValidatorService.fileTypes)]],
      //fileCertificadoTrabajadorIndependiente: ['', [requiredFileType(ValidatorService.fileTypes)]],
      //fileImposibilidadPago: ['', [requiredFileType(ValidatorService.fileTypes)]],
      //fileSituacionVulnerabilidad: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileFiniquitoCartaDespido: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileDeclaracionJuradaSimple: ['', [requiredFileType(ValidatorService.fileTypes)]],
      fileExposicionFundadaSolicitud: ['', [requiredFileType(ValidatorService.fileTypes)]],
      filePersoneria: ['', [requiredFileType(ValidatorService.fileTypes)]],
      terminos: [false, [Validators.requiredTrue]],
      postergacion: [false],
      newsletters: [false],
      boletaElectronica: [true],
      privacidad: [false, [Validators.requiredTrue]],
    });

    this.titleService.setTitle('Beneficio clientes vulnerables Covid-19 | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Si usted es cliente de Metrogas y pertenece a una de estas categorías, puede solicitar Beneficio Covid-19, que le permitirá acceder a la postergación del pago de su cuenta hasta en 48 cuotas sin interés. ' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      this.gotoPaso(1);

      this.apiService.LeerDetalleSolicitudesBeneficioCovid19V2().subscribe(res => {
        if (res.respuesta === true) {
          this.total_solicitudes = res.data.total_solicitudes;
          this.total_solicitudes_rm = res.data.total_solicitudes_rm;
          this.total_solicitudes_ohi = res.data.total_solicitudes_ohi;
          this.total_solicitudes_lla = res.data.total_solicitudes_lla;
          this.porc_total_solicitudes_rm = res.data.porc_total_solicitudes_rm;
          this.porc_total_solicitudes_ohi = res.data.porc_total_solicitudes_ohi;
          this.porc_total_solicitudes_lla = res.data.porc_total_solicitudes_lla;
          this.solicitudes_aprobadas = res.data.solicitudes_aprobadas;
          this.solicitudes_aprobadas_rm = res.data.solicitudes_aprobadas_rm;
          this.solicitudes_aprobadas_ohi = res.data.solicitudes_aprobadas_ohi;
          this.solicitudes_aprobadas_lla = res.data.solicitudes_aprobadas_lla;
          this.porc_solicitudes_aprobadas = res.data.porc_solicitudes_aprobadas;
          //this.porc_solicitudes_aprobadas_rm =  parseInt(res.data.porc_solicitudes_aprobadas_rm);
          this.porc_solicitudes_aprobadas_rm = res.data.porc_solicitudes_aprobadas_rm;
          this.porc_solicitudes_aprobadas_ohi = res.data.porc_solicitudes_aprobadas_ohi;
          this.porc_solicitudes_aprobadas_lla = res.data.porc_solicitudes_aprobadas_lla;
          this.solicitudes_pendientes_aprobacion = res.data.solicitudes_pendientes_aprobacion;
          this.solicitudes_pendientes_aprobacion_rm = res.data.solicitudes_pendientes_aprobacion_rm;
          this.solicitudes_pendientes_aprobacion_ohi = res.data.solicitudes_pendientes_aprobacion_ohi;
          this.solicitudes_pendientes_aprobacion_lla = res.data.solicitudes_pendientes_aprobacion_lla;
          this.porc_solicitudes_pendientes_aprobacion = res.data.porc_solicitudes_pendientes_aprobacion;
          this.porc_solicitudes_pendientes_aprobacion_rm = res.data.porc_solicitudes_pendientes_aprobacion_rm;
          this.porc_solicitudes_pendientes_aprobacion_ohi = res.data.porc_solicitudes_pendientes_aprobacion_ohi;
          this.porc_solicitudes_pendientes_aprobacion_lla = res.data.porc_solicitudes_pendientes_aprobacion_lla;
          this.solicitudes_rechazadas = res.data.solicitudes_rechazadas;
          this.solicitudes_rechazadas_rm = res.data.solicitudes_rechazadas_rm;
          this.solicitudes_rechazadas_ohi = res.data.solicitudes_rechazadas_ohi;
          this.solicitudes_rechazadas_lla = res.data.solicitudes_rechazadas_lla;
          this.porc_solicitudes_rechazadas = res.data.porc_solicitudes_rechazadas;
          this.porc_solicitudes_rechazadas_rm = res.data.porc_solicitudes_rechazadas_rm;
          this.porc_solicitudes_rechazadas_ohi = res.data.porc_solicitudes_rechazadas_ohi;
          this.porc_solicitudes_rechazadas_lla = res.data.porc_solicitudes_rechazadas_lla;
          this.solicitudes_desistidas = res.data.solicitudes_desistidas;
          this.solicitudes_desistidas_rm = res.data.solicitudes_desistidas_rm;
          this.solicitudes_desistidas_ohi = res.data.solicitudes_desistidas_ohi;
          this.solicitudes_desistidas_lla = res.data.solicitudes_desistidas_lla;
          this.porc_solicitudes_desistidas = res.data.porc_solicitudes_desistidas;
          this.porc_solicitudes_desistidas_rm = res.data.porc_solicitudes_desistidas_rm;
          this.porc_solicitudes_desistidas_ohi = res.data.porc_solicitudes_desistidas_ohi;
          this.porc_solicitudes_desistidas_lla = res.data.porc_solicitudes_desistidas_lla;
          this.tasa_aprobacion = res.data.tasa_aprobacion;
          this.tasa_aprobacion_rm = res.data.tasa_aprobacion_rm;
          this.tasa_aprobacion_ohi = res.data.tasa_aprobacion_ohi;
          this.tasa_aprobacion_lla = res.data.tasa_aprobacion_lla;
          this.fechaSolicitud = res.data.fecha_solicitud;
        }
        else {
          this.total_solicitudes = null;
          this.total_solicitudes_rm = null;
          this.total_solicitudes_ohi = null;
          this.total_solicitudes_lla = null;
          this.porc_total_solicitudes_rm = null;
          this.porc_total_solicitudes_ohi = null;
          this.porc_total_solicitudes_lla = null;
          this.solicitudes_aprobadas = null;
          this.solicitudes_aprobadas_rm = null;
          this.solicitudes_aprobadas_ohi = null;
          this.solicitudes_aprobadas_lla = null;
          this.porc_solicitudes_aprobadas = null;
          this.porc_solicitudes_aprobadas_rm = null;
          this.porc_solicitudes_aprobadas_ohi = null;
          this.porc_solicitudes_aprobadas_lla = null;
          this.solicitudes_pendientes_aprobacion = null;
          this.solicitudes_pendientes_aprobacion_rm = null;
          this.solicitudes_pendientes_aprobacion_ohi = null;
          this.solicitudes_pendientes_aprobacion_lla = null;
          this.porc_solicitudes_pendientes_aprobacion = null;
          this.porc_solicitudes_pendientes_aprobacion_rm = null;
          this.porc_solicitudes_pendientes_aprobacion_ohi = null;
          this.porc_solicitudes_pendientes_aprobacion_lla = null;
          this.solicitudes_rechazadas = null;
          this.solicitudes_rechazadas_rm = null;
          this.solicitudes_rechazadas_ohi = null;
          this.solicitudes_rechazadas_lla = null;
          this.porc_solicitudes_rechazadas = null;
          this.porc_solicitudes_rechazadas_rm = null;
          this.porc_solicitudes_rechazadas_ohi = null;
          this.porc_solicitudes_rechazadas_lla = null;
          this.solicitudes_desistidas = null;
          this.solicitudes_desistidas_rm = null;
          this.solicitudes_desistidas_ohi = null;
          this.solicitudes_desistidas_lla = null;
          this.porc_solicitudes_desistidas = null;
          this.porc_solicitudes_desistidas_rm = null;
          this.porc_solicitudes_desistidas_ohi = null;
          this.porc_solicitudes_desistidas_lla = null;
          this.tasa_aprobacion = null;
          this.tasa_aprobacion_rm = null;
          this.tasa_aprobacion_ohi = null;
          this.tasa_aprobacion_lla = null;
          this.fechaSolicitud = null;
        }
      });

      this.apiService.LeerRegion().subscribe(res => {
        if (res.respuesta === true) {
          this.dataRegion = this.generarDataSetRegion(res.data);
        }
      });

      this.apiService.LeerTipoInstitucion().subscribe(res => {
        if (res.respuesta === true) {
          this.dataTipoInstitucion = this.generarDataSetTipoInstitucion(res.data);
        }
      });

      this.dataCuotas = this.generarDataSetCuotas();
    }
  }

  fileRutSolProgress(fileInput: any) {
    this.fileRutSol = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageRutSol = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameRutSol = file.name;
        this.extensionRutSol = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlRutSol = reader.result;
        };

        if (this.infoMessageRutSol !== null && this.infoMessageRutSol !== "" && this.infoMessageRutSol !== undefined) {
          this.deleter.delete(this.infoMessageRutSol, this.tokenMessageRutSol).subscribe(message => {
          });
        }
        this.infoMessageRutSol = null;
        this.tokenMessageRutSol = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageRutSol = message.filename;
                this.tokenMessageRutSol = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageRutSol = null;
        this.tokenMessageRutSol = null;
        this.errorInfoMessageRutSol = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileRutSolReversoProgress(fileInput: any) {
    this.fileRutSolReverso = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageRutSolReverso = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameRutSolReverso = file.name;
        this.extensionRutSolReverso = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlRutSolReverso = reader.result;
        };

        if (this.infoMessageRutSolReverso !== null && this.infoMessageRutSolReverso !== "" && this.infoMessageRutSolReverso !== undefined) {
          this.deleter.delete(this.infoMessageRutSolReverso, this.tokenMessageRutSolReverso).subscribe(message => {
          });
        }
        this.infoMessageRutSolReverso = null;
        this.tokenMessageRutSolReverso = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageRutSolReverso = message.filename;
                this.tokenMessageRutSolReverso = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageRutSolReverso = null;
        this.tokenMessageRutSolReverso = null;
        this.errorInfoMessageRutSolReverso = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileRegistroSocialHogaresProgress(fileInput: any) {
    this.fileRegistroSocialHogares = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageRegistroSocialHogares = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameRegistroSocialHogares = file.name;
        this.extensionRegistroSocialHogares = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlRegistroSocialHogares = reader.result;
        };

        if (this.infoMessageRegistroSocialHogares !== null && this.infoMessageRegistroSocialHogares !== "" && this.infoMessageRegistroSocialHogares !== undefined) {
          this.deleter.delete(this.infoMessageRegistroSocialHogares, this.tokenMessageRegistroSocialHogares).subscribe(message => {
          });
        }
        this.infoMessageRegistroSocialHogares = null;
        this.tokenMessageRegistroSocialHogares = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageRegistroSocialHogares = message.filename;
                this.tokenMessageRegistroSocialHogares = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageRegistroSocialHogares = null;
        this.tokenMessageRegistroSocialHogares = null;
        this.errorInfoMessageRegistroSocialHogares = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileAcreditacionResidenciaProgress(fileInput: any) {
    this.fileAcreditacionResidencia = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageAcreditacionResidencia = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameAcreditacionResidencia = file.name;
        this.extensionAcreditacionResidencia = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlAcreditacionResidencia = reader.result;
        };

        if (this.infoMessageAcreditacionResidencia !== null && this.infoMessageAcreditacionResidencia !== "" && this.infoMessageAcreditacionResidencia !== undefined) {
          this.deleter.delete(this.infoMessageAcreditacionResidencia, this.tokenMessageAcreditacionResidencia).subscribe(message => {
          });
        }
        this.infoMessageAcreditacionResidencia = null;
        this.tokenMessageAcreditacionResidencia = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageAcreditacionResidencia = message.filename;
                this.tokenMessageAcreditacionResidencia = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageAcreditacionResidencia = null;
        this.tokenMessageAcreditacionResidencia = null;
        this.errorInfoMessageAcreditacionResidencia = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileActivacionSeguroCesantiaProgress(fileInput: any) {
    this.fileActivacionSeguroCesantia = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageActivacionSeguroCesantia = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameActivacionSeguroCesantia = file.name;
        this.extensionActivacionSeguroCesantia = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlActivacionSeguroCesantia = reader.result;
        };

        if (this.infoMessageActivacionSeguroCesantia !== null && this.infoMessageActivacionSeguroCesantia !== "" && this.infoMessageActivacionSeguroCesantia !== undefined) {
          this.deleter.delete(this.infoMessageActivacionSeguroCesantia, this.tokenMessageActivacionSeguroCesantia).subscribe(message => {
          });
        }
        this.infoMessageActivacionSeguroCesantia = null;
        this.tokenMessageActivacionSeguroCesantia = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageActivacionSeguroCesantia = message.filename;
                this.tokenMessageActivacionSeguroCesantia = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageActivacionSeguroCesantia = null;
        this.tokenMessageActivacionSeguroCesantia = null;
        this.errorInfoMessageActivacionSeguroCesantia = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileAnexoContratoProgress(fileInput: any) {
    this.fileAnexoContrato = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageAnexoContrato = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameAnexoContrato = file.name;
        this.extensionAnexoContrato = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlAnexoContrato = reader.result;
        };

        if (this.infoMessageAnexoContrato !== null && this.infoMessageAnexoContrato !== "" && this.infoMessageAnexoContrato !== undefined) {
          this.deleter.delete(this.infoMessageAnexoContrato, this.tokenMessageAnexoContrato).subscribe(message => {
          });
        }
        this.infoMessageAnexoContrato = null;
        this.tokenMessageAnexoContrato = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageAnexoContrato = message.filename;
                this.tokenMessageAnexoContrato = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageAnexoContrato = null;
        this.tokenMessageAnexoContrato = null;
        this.errorInfoMessageAnexoContrato = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  /*fileCertificadoTrabajadorIndependienteProgress(fileInput: any) {
    this.fileCertificadoTrabajadorIndependiente = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageCertificadoTrabajadorIndependiente = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x=> x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameCertificadoTrabajadorIndependiente = file.name;
        this.extensionCertificadoTrabajadorIndependiente = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlCertificadoTrabajadorIndependiente = reader.result;
        };

        if (this.infoMessageCertificadoTrabajadorIndependiente !== null && this.infoMessageCertificadoTrabajadorIndependiente !== "" && this.infoMessageCertificadoTrabajadorIndependiente !== undefined)
        {
          this.deleter.delete(this.infoMessageCertificadoTrabajadorIndependiente, this.tokenMessageCertificadoTrabajadorIndependiente).subscribe(message => {
          });
        }
        this.infoMessageCertificadoTrabajadorIndependiente = null;
        this.tokenMessageCertificadoTrabajadorIndependiente = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
        .subscribe(
          (token) => {
            this.uploader.upload(this.file, token).subscribe(message => {
              this.infoMessageCertificadoTrabajadorIndependiente = message.filename;
              this.tokenMessageCertificadoTrabajadorIndependiente = message.token;
              this.spinner.hide();
            });
          },
          (error) => {
            this.spinner.hide();
          },
        );
      }
      else {
        this.infoMessageCertificadoTrabajadorIndependiente = null;
        this.tokenMessageCertificadoTrabajadorIndependiente = null;
        this.errorInfoMessageCertificadoTrabajadorIndependiente = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }*/

  /*fileImposibilidadPagoProgress(fileInput: any) {
    this.fileImposibilidadPago = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageImposibilidadPago = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x=> x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameImposibilidadPago = file.name;
        this.extensionImposibilidadPago = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlImposibilidadPago = reader.result;
        };

        if (this.infoMessageImposibilidadPago !== null && this.infoMessageImposibilidadPago !== "" && this.infoMessageImposibilidadPago !== undefined)
        {
          this.deleter.delete(this.infoMessageImposibilidadPago, this.tokenMessageImposibilidadPago).subscribe(message => {
          });
        }
        this.infoMessageImposibilidadPago = null;
        this.tokenMessageImposibilidadPago = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
        .subscribe(
          (token) => {
            this.uploader.upload(this.file, token).subscribe(message => {
              this.infoMessageImposibilidadPago = message.filename;
              this.tokenMessageImposibilidadPago = message.token;
              this.spinner.hide();
            });
          },
          (error) => {
            this.spinner.hide();
          },
        );
      }
      else {
        this.infoMessageImposibilidadPago = null;
        this.tokenMessageImposibilidadPago = null;
        this.errorInfoMessageImposibilidadPago = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }*/

  /*fileSituacionVulnerabilidadProgress(fileInput: any) {
    this.fileSituacionVulnerabilidad = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageSituacionVulnerabilidad = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x=> x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameSituacionVulnerabilidad = file.name;
        this.extensionSituacionVulnerabilidad = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlSituacionVulnerabilidad = reader.result;
        };

        if (this.infoMessageSituacionVulnerabilidad !== null && this.infoMessageSituacionVulnerabilidad !== "" && this.infoMessageSituacionVulnerabilidad !== undefined)
        {
          this.deleter.delete(this.infoMessageSituacionVulnerabilidad, this.tokenMessageSituacionVulnerabilidad).subscribe(message => {
          });
        }
        this.infoMessageSituacionVulnerabilidad = null;
        this.tokenMessageSituacionVulnerabilidad = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
        .subscribe(
          (token) => {
            this.uploader.upload(this.file, token).subscribe(message => {
              this.infoMessageSituacionVulnerabilidad = message.filename;
              this.tokenMessageSituacionVulnerabilidad = message.token;
              this.spinner.hide();
            });
          },
          (error) => {
            this.spinner.hide();
          },
        );
      }
      else {
        this.infoMessageSituacionVulnerabilidad = null;
        this.tokenMessageSituacionVulnerabilidad = null;
        this.errorInfoMessageSituacionVulnerabilidad = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }*/

  fileFiniquitoCartaDespidoProgress(fileInput: any) {
    this.fileFiniquitoCartaDespido = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageFiniquitoCartaDespido = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameFiniquitoCartaDespido = file.name;
        this.extensionFiniquitoCartaDespido = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlFiniquitoCartaDespido = reader.result;
        };

        if (this.infoMessageFiniquitoCartaDespido !== null && this.infoMessageFiniquitoCartaDespido !== "" && this.infoMessageFiniquitoCartaDespido !== undefined) {
          this.deleter.delete(this.infoMessageFiniquitoCartaDespido, this.tokenMessageFiniquitoCartaDespido).subscribe(message => {
          });
        }
        this.infoMessageFiniquitoCartaDespido = null;
        this.tokenMessageFiniquitoCartaDespido = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageFiniquitoCartaDespido = message.filename;
                this.tokenMessageFiniquitoCartaDespido = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageFiniquitoCartaDespido = null;
        this.tokenMessageFiniquitoCartaDespido = null;
        this.errorInfoMessageFiniquitoCartaDespido = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileDeclaracionJuradaSimpleProgress(fileInput: any) {
    this.fileDeclaracionJuradaSimple = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageDeclaracionJuradaSimple = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameDeclaracionJuradaSimple = file.name;
        this.extensionDeclaracionJuradaSimple = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlDeclaracionJuradaSimple = reader.result;
        };

        if (this.infoMessageDeclaracionJuradaSimple !== null && this.infoMessageDeclaracionJuradaSimple !== "" && this.infoMessageDeclaracionJuradaSimple !== undefined) {
          this.deleter.delete(this.infoMessageDeclaracionJuradaSimple, this.tokenMessageDeclaracionJuradaSimple).subscribe(message => {
          });
        }
        this.infoMessageDeclaracionJuradaSimple = null;
        this.tokenMessageDeclaracionJuradaSimple = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageDeclaracionJuradaSimple = message.filename;
                this.tokenMessageDeclaracionJuradaSimple = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageDeclaracionJuradaSimple = null;
        this.tokenMessageDeclaracionJuradaSimple = null;
        this.errorInfoMessageDeclaracionJuradaSimple = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileExposicionFundadaSolicitudProgress(fileInput: any) {
    this.fileExposicionFundadaSolicitud = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessageExposicionFundadaSolicitud = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNameExposicionFundadaSolicitud = file.name;
        this.extensionExposicionFundadaSolicitud = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlExposicionFundadaSolicitud = reader.result;
        };

        if (this.infoMessageExposicionFundadaSolicitud !== null && this.infoMessageExposicionFundadaSolicitud !== "" && this.infoMessageExposicionFundadaSolicitud !== undefined) {
          this.deleter.delete(this.infoMessageExposicionFundadaSolicitud, this.tokenMessageExposicionFundadaSolicitud).subscribe(message => {
          });
        }
        this.infoMessageExposicionFundadaSolicitud = null;
        this.tokenMessageExposicionFundadaSolicitud = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessageExposicionFundadaSolicitud = message.filename;
                this.tokenMessageExposicionFundadaSolicitud = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessageExposicionFundadaSolicitud = null;
        this.tokenMessageExposicionFundadaSolicitud = null;
        this.errorInfoMessageExposicionFundadaSolicitud = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  filePersoneriaProgress(fileInput: any) {
    this.filePersoneria = <File>fileInput.target.files[0];

    let file: File;
    file = <File>fileInput.target.files[0];
    this.errorInfoMessagePersoneria = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileNamePersoneria = file.name;
        this.extensionPersoneria = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrlPersoneria = reader.result;
        };

        if (this.infoMessagePersoneria !== null && this.infoMessagePersoneria !== "" && this.infoMessagePersoneria !== undefined) {
          this.deleter.delete(this.infoMessagePersoneria, this.tokenMessagePersoneria).subscribe(message => {
          });
        }
        this.infoMessagePersoneria = null;
        this.tokenMessagePersoneria = null;

        this.recaptchaV3Service.execute('UploadFileBeneficioCovid19')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessagePersoneria = message.filename;
                this.tokenMessagePersoneria = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      }
      else {
        this.infoMessagePersoneria = null;
        this.tokenMessagePersoneria = null;
        this.errorInfoMessagePersoneria = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  eliminarArchivo(numero: number, fileUpload: string) {
    this.spinner.show();
    this.formData.controls[fileUpload].reset();
    if (numero === 1 && this.infoMessageRutSol !== null && this.infoMessageRutSol !== "" && this.infoMessageRutSol !== undefined) {
      this.deleter.delete(this.infoMessageRutSol, this.tokenMessageRutSol).subscribe(message => {
      });
      this.infoMessageRutSol = null;
      this.tokenMessageRutSol = null;
    }
    else if (numero === 2 && this.infoMessageRegistroSocialHogares !== null && this.infoMessageRegistroSocialHogares !== "" && this.infoMessageRegistroSocialHogares !== undefined) {
      this.deleter.delete(this.infoMessageRegistroSocialHogares, this.tokenMessageRegistroSocialHogares).subscribe(message => {
      });
      this.infoMessageRegistroSocialHogares = null;
      this.tokenMessageRegistroSocialHogares = null;
    }
    else if (numero === 3 && this.infoMessageAcreditacionResidencia !== null && this.infoMessageAcreditacionResidencia !== "" && this.infoMessageAcreditacionResidencia !== undefined) {
      this.deleter.delete(this.infoMessageAcreditacionResidencia, this.tokenMessageAcreditacionResidencia).subscribe(message => {
      });
      this.infoMessageAcreditacionResidencia = null;
      this.tokenMessageAcreditacionResidencia = null;
    }
    else if (numero === 4 && this.infoMessageActivacionSeguroCesantia !== null && this.infoMessageActivacionSeguroCesantia !== "" && this.infoMessageActivacionSeguroCesantia !== undefined) {
      this.deleter.delete(this.infoMessageActivacionSeguroCesantia, this.tokenMessageActivacionSeguroCesantia).subscribe(message => {
      });
      this.infoMessageActivacionSeguroCesantia = null;
      this.tokenMessageActivacionSeguroCesantia = null;
    }
    else if (numero === 5 && this.infoMessageAnexoContrato !== null && this.infoMessageAnexoContrato !== "" && this.infoMessageAnexoContrato !== undefined) {
      this.deleter.delete(this.infoMessageAnexoContrato, this.tokenMessageAnexoContrato).subscribe(message => {
      });
      this.infoMessageAnexoContrato = null;
      this.tokenMessageAnexoContrato = null;
    }
    /*else if (numero === 6 && this.infoMessageCertificadoTrabajadorIndependiente !== null && this.infoMessageCertificadoTrabajadorIndependiente !== "" && this.infoMessageCertificadoTrabajadorIndependiente !== undefined) {
      this.deleter.delete(this.infoMessageCertificadoTrabajadorIndependiente, this.tokenMessageCertificadoTrabajadorIndependiente).subscribe(message => {
      });
      this.infoMessageCertificadoTrabajadorIndependiente = null;
      this.tokenMessageCertificadoTrabajadorIndependiente = null;
    }*/
    /*else if (numero === 7 && this.infoMessageImposibilidadPago !== null && this.infoMessageImposibilidadPago !== "" && this.infoMessageImposibilidadPago !== undefined) {
      this.deleter.delete(this.infoMessageImposibilidadPago, this.tokenMessageImposibilidadPago).subscribe(message => {
      });
      this.infoMessageImposibilidadPago = null;
      this.tokenMessageImposibilidadPago = null;
    }*/
    /*else if (numero === 8 && this.infoMessageSituacionVulnerabilidad !== null && this.infoMessageSituacionVulnerabilidad !== "" && this.infoMessageSituacionVulnerabilidad !== undefined) {
      this.deleter.delete(this.infoMessageSituacionVulnerabilidad, this.tokenMessageSituacionVulnerabilidad).subscribe(message => {
      });
      this.infoMessageSituacionVulnerabilidad = null;
      this.tokenMessageSituacionVulnerabilidad = null;
    }*/
    else if (numero === 9 && this.infoMessageFiniquitoCartaDespido !== null && this.infoMessageFiniquitoCartaDespido !== "" && this.infoMessageFiniquitoCartaDespido !== undefined) {
      this.deleter.delete(this.infoMessageFiniquitoCartaDespido, this.tokenMessageFiniquitoCartaDespido).subscribe(message => {
      });
      this.infoMessageFiniquitoCartaDespido = null;
      this.tokenMessageFiniquitoCartaDespido = null;
    }
    else if (numero === 10 && this.infoMessageDeclaracionJuradaSimple !== null && this.infoMessageDeclaracionJuradaSimple !== "" && this.infoMessageDeclaracionJuradaSimple !== undefined) {
      this.deleter.delete(this.infoMessageDeclaracionJuradaSimple, this.tokenMessageDeclaracionJuradaSimple).subscribe(message => {
      });
      this.infoMessageDeclaracionJuradaSimple = null;
      this.tokenMessageDeclaracionJuradaSimple = null;
    }
    else if (numero === 11 && this.infoMessageExposicionFundadaSolicitud !== null && this.infoMessageExposicionFundadaSolicitud !== "" && this.infoMessageExposicionFundadaSolicitud !== undefined) {
      this.deleter.delete(this.infoMessageExposicionFundadaSolicitud, this.tokenMessageExposicionFundadaSolicitud).subscribe(message => {
      });
      this.infoMessageExposicionFundadaSolicitud = null;
      this.tokenMessageExposicionFundadaSolicitud = null;
    }
    else if (numero === 12 && this.infoMessagePersoneria !== null && this.infoMessagePersoneria !== "" && this.infoMessagePersoneria !== undefined) {
      this.deleter.delete(this.infoMessagePersoneria, this.tokenMessagePersoneria).subscribe(message => {
      });
      this.infoMessagePersoneria = null;
      this.tokenMessagePersoneria = null;
    }
    else if (numero === 13 && this.infoMessageRutSolReverso !== null && this.infoMessageRutSolReverso !== "" && this.infoMessageRutSolReverso !== undefined) {
      this.deleter.delete(this.infoMessageRutSolReverso, this.tokenMessageRutSolReverso).subscribe(message => {
      });
      this.infoMessageRutSolReverso = null;
      this.tokenMessageRutSolReverso = null;
    }

    this.spinner.hide();
  }

  lightboxFile(numero: number) {
    let archivo;
    let extension;

    if (numero === 1) {
      archivo = this.imageUrlRutSol;
      extension = this.extensionRutSol.toLowerCase();
    }
    else if (numero === 2) {
      archivo = this.imageUrlRegistroSocialHogares;
      extension = this.extensionRegistroSocialHogares.toLowerCase();
    }
    else if (numero === 3) {
      archivo = this.imageUrlAcreditacionResidencia;
      extension = this.extensionAcreditacionResidencia.toLowerCase();
    }
    else if (numero === 4) {
      archivo = this.imageUrlActivacionSeguroCesantia;
      extension = this.extensionActivacionSeguroCesantia.toLowerCase();
    }
    else if (numero === 5) {
      archivo = this.imageUrlAnexoContrato;
      extension = this.extensionAnexoContrato.toLowerCase();
    }
    /*else if (numero === 6) {
      archivo = this.imageUrlCertificadoTrabajadorIndependiente;
      extension = this.extensionCertificadoTrabajadorIndependiente.toLowerCase();
    }*/
    /*else if (numero === 7) {
      archivo = this.imageUrlImposibilidadPago;
      extension = this.extensionImposibilidadPago.toLowerCase();
    }*/
    /*else if (numero === 8) {
      archivo = this.imageUrlSituacionVulnerabilidad;
      extension = this.extensionSituacionVulnerabilidad.toLowerCase();
    }*/
    else if (numero === 9) {
      archivo = this.imageUrlFiniquitoCartaDespido;
      extension = this.extensionFiniquitoCartaDespido.toLowerCase();
    }
    else if (numero === 10) {
      archivo = this.imageUrlDeclaracionJuradaSimple;
      extension = this.extensionDeclaracionJuradaSimple.toLowerCase();
    }
    else if (numero === 11) {
      archivo = this.imageUrlExposicionFundadaSolicitud;
      extension = this.extensionExposicionFundadaSolicitud.toLowerCase();
    }
    else if (numero === 12) {
      archivo = this.imageUrlPersoneria;
      extension = this.extensionPersoneria.toLowerCase();
    }
    else if (numero === 13) {
      archivo = this.imageUrlRutSolReverso;
      extension = this.extensionRutSolReverso.toLowerCase();
    }

    const instance = basicLightbox.create(
      extension === "png" || extension === "pjp" || extension === "jpg" || extension === "pjpeg" || extension === "jpeg" || extension === "jfif" ?
        "<img class='zoom-ligthbox' src='" + archivo + "'>" :
        extension === "pdf" ?
          "<embed class='zoom-pdf' src='" + archivo + "' type='application/pdf' />" :
          extension === "doc" || extension === "docx" ?
            `"<iframe class='zoom-word' src='https://docs.google.com/gview?url=${GlobalConstants.apiResponseFile}&embedded=true'></iframe>"` :
            "<img class='zoom-ligthbox' src='" + archivo + "'>"
      , {
        closable: true
      });
    instance.show();
  }

  mostrarTerminos(objeto) {
    this.dialog.open(ModalPoliticaPrivacidadComponent);
  }

  mostrarPrivacidad(objeto) {
    this.lightboxDiv('.modal-privacidad');
  }

  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {
        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  lightboxEjemploDeclaracionJurada() {
    this.lightboxDiv('.modal-declaracion-jurada');
  }

  lightboxDiv(claseCss) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
      closable: true
    });

    instance.show();
  }

  get f() { return this.formData.controls; }
  onSubmit() {
    this.spinner.show();
    this.submitted = true;
    if (this.formData.invalid) {
      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    }
    else {
      this.recaptchaV3Service.execute('SubmitBeneficioCovid19')
        .subscribe(
          (token) => {
            let beneficioClientesVulnerablesCovid19 = new BeneficioClientesVulnerablesCovid19();
            beneficioClientesVulnerablesCovid19.criterio_beneficio_covid19 = this.perfil;
            beneficioClientesVulnerablesCovid19.id_tipo_institucion = this.formData.value.tipoInstitucion;
            beneficioClientesVulnerablesCovid19.rut = this.formatearTextoRut(this.formData.value.rut);
            beneficioClientesVulnerablesCovid19.nombre = this.formData.value.nombre;
            beneficioClientesVulnerablesCovid19.telefono = this.formData.value.telefono;
            beneficioClientesVulnerablesCovid19.email = this.formData.value.email;
            beneficioClientesVulnerablesCovid19.numero_cliente = this.formData.value.nCliente;
            beneficioClientesVulnerablesCovid19.direccion = this.formData.value.direccion;
            beneficioClientesVulnerablesCovid19.id_comuna = this.formData.value.comuna;
            beneficioClientesVulnerablesCovid19.id_region = this.formData.value.region;
            beneficioClientesVulnerablesCovid19.motivo_imposibilidad_pago = this.formData.value.detalleSituacion;
            beneficioClientesVulnerablesCovid19.numero_cuotas = this.formData.value.numeroCuotas;
            beneficioClientesVulnerablesCovid19.archivo_cedula_identidad = this.infoMessageRutSol;
            beneficioClientesVulnerablesCovid19.archivo_cedula_identidad_reverso = this.infoMessageRutSolReverso;
            beneficioClientesVulnerablesCovid19.archivo_registro_social_hogares = this.infoMessageRegistroSocialHogares;
            beneficioClientesVulnerablesCovid19.archivo_acreditacion_residencia = this.infoMessageAcreditacionResidencia;
            beneficioClientesVulnerablesCovid19.archivo_solicitud_activacion_seguro_cesantia = this.infoMessageActivacionSeguroCesantia;
            beneficioClientesVulnerablesCovid19.archivo_reduccion_suspension_jornada_laboral = this.infoMessageAnexoContrato;
            //beneficioClientesVulnerablesCovid19.archivo_certifica_trabajador_independiente = this.infoMessageCertificadoTrabajadorIndependiente;
            //beneficioClientesVulnerablesCovid19.archivo_imposibilidad_pago = this.infoMessageImposibilidadPago;
            //beneficioClientesVulnerablesCovid19.archivo_situacion_vulnerabilidad = this.infoMessageSituacionVulnerabilidad;
            beneficioClientesVulnerablesCovid19.archivo_finiquito_carta_despido = this.infoMessageFiniquitoCartaDespido;
            beneficioClientesVulnerablesCovid19.archivo_declaracion_jurada_simple = this.infoMessageDeclaracionJuradaSimple;
            beneficioClientesVulnerablesCovid19.archivo_exposicion_fundada_solicitud = this.infoMessageExposicionFundadaSolicitud;
            beneficioClientesVulnerablesCovid19.archivo_personeria = this.infoMessagePersoneria;
            //beneficioClientesVulnerablesCovid19.acepto_condiciones = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            beneficioClientesVulnerablesCovid19.acepto_postergacion_pago = this.formData.value.postergacion === null ? false : this.formData.value.postergacion;
            beneficioClientesVulnerablesCovid19.acepto_newsletters = this.formData.value.newsletters === null ? false : this.formData.value.newsletters;
            beneficioClientesVulnerablesCovid19.acepto_boleta_electronica = this.formData.value.boletaElectronica === null ? false : this.formData.value.boletaElectronica;
            beneficioClientesVulnerablesCovid19.acepto_privacidad = this.formData.value.newsletters === null ? false : this.formData.value.privacidad;
            beneficioClientesVulnerablesCovid19.token = token;

            const formulario = new FormData();
            formulario.append("data", JSON.stringify(beneficioClientesVulnerablesCovid19));

            this.apiService.AgregarBeneficioClientesVulnerablesCovid19(formulario, beneficioClientesVulnerablesCovid19).subscribe(res => {
              if (res.respuesta === true) {
                this.gotoPaso(4);
              }
              else {
                this.lightboxDiv('.modal-error');
              }
              this.spinner.hide();
            });
          },
          (error) => {
            this.lightboxDiv('.modal-error');
            this.spinner.hide();
          },
        );
    }
  }

  onReset() {
    this.submitted = false;
    this.formData.reset();
  }

  formatearRut(objeto) {
    objeto.target.value = this.rutService.transform(objeto.target.value);
  }

  formatearTextoRut(texto) {
    return (texto === null || texto === undefined) ? "" : this.rutService.transform(texto);
  }

  gotoPaso(index) {
    switch (index) {
      case 1:
        this.pasos[0]['P1'].I = true;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = false;
        this.pasos[0]['P4'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '33%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = false;
            this.pasos[0]['P3'].CurrentNum = false;
            this.pasos[0]['P4'].CurrentNum = false;
            $(".paso-1")[0].scrollIntoView();
          }
        });
        break;
      case 2:
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = true;
        this.pasos[0]['P3'].I = false;
        this.pasos[0]['P4'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '33%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = false;
            this.pasos[0]['P4'].CurrentNum = false;
            $(".paso-2")[0].scrollIntoView();
          }
        });
        break;
      case 3:
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = true;
        this.pasos[0]['P4'].I = false;
        TweenMax.to('.linea-current', 1, {
          width: '66%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = true;
            this.pasos[0]['P4'].CurrentNum = false;
            $(".paso-3-beneficios")[0].scrollIntoView();
          }
        });
        break;
      case 4:
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = false;
        this.pasos[0]['P4'].I = true;
        //$("app-boleta").show();
        $("app-emergencia").show();
        TweenMax.to('.linea-current', 1, {
          width: '100%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = true;
            this.pasos[0]['P4'].CurrentNum = true;
            $(".paso-4")[0].scrollIntoView();
          }
        });
        break;
    }
  }

  onChangeRegion(obj) {
    this.spinner.show();
    if (obj) {
      this.apiService.LeerComunaRegion(obj.id_region).subscribe(res => {
        if (res.respuesta === true) {
          this.dataComuna = this.generarDataSetComuna(res.data);
          this.comunaOk.handleClearClick();
        }
        this.spinner.hide();
      });
    }
    else {
      this.dataComuna = null;
      this.comunaOk.handleClearClick();
      this.spinner.hide();
    }
  }

  onChangeDireccion(obj) {
    if (obj) {
      this.formData.controls.nCliente.setValue(obj.numero_cliente);
    }
    else {
      this.dataDirecciones = null;
      this.formData.controls.nCliente.reset();
    }
  }

  generarDataSetComuna(data: any) {
    data.forEach(element => {
      element.id = element.id_comuna;
    });
    return data;
  }

  generarDataSetRegion(data: any) {
    data.forEach(element => {
      element.id = element.id_region;
    });
    return data;
  }

  generarDataSetTipoInstitucion(data: any) {
    data.forEach(element => {
      element.id = element.id_tipo_institucion;
    });
    return data;
  }

  generarDataSetCuotas() {
    let data = [];
    for (let index = 48; index >= 1; index--) {
      data.push({ id: index, valor: index });
    }
    return data;
  }

  generarDataSetDirecciones(data: any) {
    data.forEach(element => {
      element.id = element.direccion;
    });
    return data;
  }

  seleccionPerfil(perfil: string) {
    this.limpiarVariables();
    this.perfil = perfil;
    this.customValidator();
    this.gotoPaso(2);
  }

  seleccionDatosNumeroCliente() {
    let id_region;
    let id_comuna;

    if (this.formData.controls.nCliente.value && this.formData.controls.nCliente.valid) {
      this.spinner.show();
      const numeroCliente = this.formData.value.nCliente;
      this.apiService.LeerDatosPorNumeroCliente(numeroCliente).subscribe(res => {
        if (res.respuesta === true) {
          this.formData.controls.direccion.setValue(res.data.direccion);
          this.formData.controls.region.setValue(res.data.id_region);

          id_region = res.data.id_region;
          id_comuna = res.data.id_comuna;

          this.apiService.LeerComunaRegion(id_region).subscribe(res => {
            if (res.respuesta === true) {
              this.dataComuna = this.generarDataSetComuna(res.data);
              this.comunaOk.handleClearClick();

              this.formData.controls.comuna.setValue(id_comuna);
            }

            this.spinner.hide();
          });
        }
        else {
          this.formData.controls.direccion.reset();
          this.formData.controls.region.reset();
          this.formData.controls.comuna.reset();
          this.spinner.hide();
        }
      });
    }
    else {
      this.formData.controls.direccion.reset();
      this.formData.controls.region.reset();
      this.formData.controls.comuna.reset();
      this.spinner.hide();
    }
  }

  obtenerDirecciones(obj) {
    let id_region;
    let id_comuna;
    let direccion;

    if (obj && obj.term && obj.term.length > 3 && this.formData.controls.region.valid && this.formData.controls.comuna.valid) {
      let id_region = this.formData.controls.region.value;
      let id_comuna = this.formData.controls.comuna.value;
      let direccion = obj.term;

      const numeroCliente = this.formData.value.nCliente;
      this.apiService.LeerDatosDirecciones(id_region, id_comuna, direccion).subscribe(res => {
        if (res.respuesta === true) {
          this.dataDirecciones = this.generarDataSetDirecciones(res.data);
        }
        else {
          this.spinner.hide();
        }
      });
    }
  }

  limpiarVariables() {
    this.fileRutSol = null;
    this.fileRutSolReverso = null;
    this.fileRegistroSocialHogares = null;
    this.fileAcreditacionResidencia = null;
    this.fileActivacionSeguroCesantia = null;
    this.fileAnexoContrato = null;
    //this.fileCertificadoTrabajadorIndependiente = null;
    //this.fileImposibilidadPago = null;
    //this.fileSituacionVulnerabilidad = null;
    this.fileFiniquitoCartaDespido = null;
    this.fileDeclaracionJuradaSimple = null;
    this.fileExposicionFundadaSolicitud = null;
    this.filePersoneria = null;

    this.submitted = false;
    this.perfil = null;

    this.infoMessageRutSol = null;
    this.infoMessageRegistroSocialHogares = null;
    this.infoMessageAcreditacionResidencia = null;
    this.infoMessageActivacionSeguroCesantia = null;
    this.infoMessageAnexoContrato = null;
    //this.infoMessageCertificadoTrabajadorIndependiente = null;
    //this.infoMessageImposibilidadPago = null;
    //this.infoMessageSituacionVulnerabilidad = null;
    this.infoMessageFiniquitoCartaDespido = null;
    this.infoMessageDeclaracionJuradaSimple = null;
    this.infoMessageExposicionFundadaSolicitud = null;
    this.infoMessagePersoneria = null;

    this.tokenMessageRutSol = null;
    this.tokenMessageRutSolReverso = null;
    this.tokenMessageRegistroSocialHogares = null;
    this.tokenMessageAcreditacionResidencia = null;
    this.tokenMessageActivacionSeguroCesantia = null;
    this.tokenMessageAnexoContrato = null;
    //this.tokenMessageCertificadoTrabajadorIndependiente = null;
    //this.tokenMessageImposibilidadPago = null;
    //this.tokenMessageSituacionVulnerabilidad = null;
    this.tokenMessageFiniquitoCartaDespido = null;
    this.tokenMessageDeclaracionJuradaSimple = null;
    this.tokenMessageExposicionFundadaSolicitud = null;
    this.tokenMessagePersoneria = null;

    this.errorInfoMessageRutSol = null;
    this.errorInfoMessageRegistroSocialHogares = null;
    this.errorInfoMessageAcreditacionResidencia = null;
    this.errorInfoMessageActivacionSeguroCesantia = null;
    this.errorInfoMessageAnexoContrato = null;
    //this.errorInfoMessageCertificadoTrabajadorIndependiente = null;
    //this.errorInfoMessageImposibilidadPago = null;
    //this.errorInfoMessageSituacionVulnerabilidad = null;
    this.errorInfoMessageFiniquitoCartaDespido = null;
    this.errorInfoMessageDeclaracionJuradaSimple = null;
    this.errorInfoMessageExposicionFundadaSolicitud = null;
    this.errorInfoMessagePersoneria = null;

    //this.file: File;
    this.fileNameRutSol = "";
    this.fileNameRegistroSocialHogares = "";
    this.fileNameAcreditacionResidencia = "";
    this.fileNameActivacionSeguroCesantia = "";
    this.fileNameAnexoContrato = "";
    //this.fileNameCertificadoTrabajadorIndependiente = "";
    //this.fileNameImposibilidadPago = "";
    //this.fileNameSituacionVulnerabilidad = "";
    this.fileNameFiniquitoCartaDespido = "";
    this.fileNameDeclaracionJuradaSimple = "";
    this.fileNameExposicionFundadaSolicitud = "";
    this.fileNamePersoneria = "";

    this.extensionRutSol = "";
    this.extensionRegistroSocialHogares = "";
    this.extensionAcreditacionResidencia = "";
    this.extensionActivacionSeguroCesantia = "";
    this.extensionAnexoContrato = "";
    //this.extensionCertificadoTrabajadorIndependiente = "";
    //this.extensionImposibilidadPago = "";
    //this.extensionSituacionVulnerabilidad = "";
    this.extensionFiniquitoCartaDespido = "";
    this.extensionDeclaracionJuradaSimple = "";
    this.extensionExposicionFundadaSolicitud = "";
    this.extensionPersoneria = "";

    this.imageUrlRutSol = "";
    this.imageUrlRegistroSocialHogares = "";
    this.imageUrlAcreditacionResidencia = "";
    this.imageUrlActivacionSeguroCesantia = "";
    this.imageUrlAnexoContrato = "";
    //this.imageUrlCertificadoTrabajadorIndependiente = "";
    //this.imageUrlImposibilidadPago = "";
    //this.imageUrlSituacionVulnerabilidad = "";
    this.imageUrlFiniquitoCartaDespido = "";
    this.imageUrlDeclaracionJuradaSimple = "";
    this.imageUrlExposicionFundadaSolicitud = "";
    this.imageUrlPersoneria = "";

    this.formData.controls.tipoInstitucion.reset();
    this.formData.controls.nombre.reset();
    this.formData.controls.rut.reset();
    this.formData.controls.telefono.reset();
    this.formData.controls.email.reset();
    this.formData.controls.nCliente.reset();
    this.formData.controls.direccion.reset();
    this.formData.controls.comuna.reset();
    this.formData.controls.region.reset();
    this.formData.controls.detalleSituacion.reset();
    this.formData.controls.numeroCuotas.reset();
    this.formData.controls.fileRutSol.reset();
    this.formData.controls.fileRutSolReverso.reset();
    this.formData.controls.fileRegistroSocialHogares.reset();
    this.formData.controls.fileAcreditacionResidencia.reset();
    this.formData.controls.fileActivacionSeguroCesantia.reset();
    this.formData.controls.fileAnexoContrato.reset();
    //this.formData.controls.fileCertificadoTrabajadorIndependiente.reset();
    //this.formData.controls.fileImposibilidadPago.reset();
    //this.formData.controls.fileSituacionVulnerabilidad.reset();
    this.formData.controls.fileFiniquitoCartaDespido.reset();
    this.formData.controls.fileDeclaracionJuradaSimple.reset();
    this.formData.controls.fileExposicionFundadaSolicitud.reset();
    this.formData.controls.filePersoneria.reset();
    this.formData.controls.terminos.reset();
    this.formData.controls.postergacion.reset();
    this.formData.controls.newsletters.reset();
    this.formData.controls.boletaElectronica.reset();
    this.formData.controls.boletaElectronica.setValue(true);
  }

  customValidator() {
    if (this.perfil === this.textosCovid19.hogarVulnerable) {
      this.formData.controls.fileRutSol.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRutSolReverso.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRegistroSocialHogares.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.fileAcreditacionResidencia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileActivacionSeguroCesantia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAnexoContrato.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileCertificadoTrabajadorIndependiente.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileImposibilidadPago.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileSituacionVulnerabilidad.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileFiniquitoCartaDespido.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileDeclaracionJuradaSimple.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileExposicionFundadaSolicitud.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.filePersoneria.setValidators([requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.tipoInstitucion.setValidators(null);
    }
    else if (this.perfil === this.textosCovid19.adultoMayor) {
      this.formData.controls.fileRutSol.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRutSolReverso.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAcreditacionResidencia.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.fileDeclaracionJuradaSimple.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRegistroSocialHogares.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileActivacionSeguroCesantia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAnexoContrato.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileCertificadoTrabajadorIndependiente.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileImposibilidadPago.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileSituacionVulnerabilidad.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileFiniquitoCartaDespido.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileExposicionFundadaSolicitud.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.filePersoneria.setValidators([requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.tipoInstitucion.setValidators(null);
    }
    else if (this.perfil === this.textosCovid19.recibiendoSeguroDesempleo) {
      this.formData.controls.fileRutSol.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRutSolReverso.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAcreditacionResidencia.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileActivacionSeguroCesantia.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.fileFiniquitoCartaDespido.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRegistroSocialHogares.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAnexoContrato.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileCertificadoTrabajadorIndependiente.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileImposibilidadPago.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileSituacionVulnerabilidad.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileDeclaracionJuradaSimple.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileExposicionFundadaSolicitud.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.filePersoneria.setValidators([requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.tipoInstitucion.setValidators(null);
    }
    else if (this.perfil === this.textosCovid19.suspensionReduccionJornada) {
      this.formData.controls.fileRutSol.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRutSolReverso.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAcreditacionResidencia.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAnexoContrato.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.fileDeclaracionJuradaSimple.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRegistroSocialHogares.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileActivacionSeguroCesantia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileCertificadoTrabajadorIndependiente.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileImposibilidadPago.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileSituacionVulnerabilidad.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileFiniquitoCartaDespido.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileExposicionFundadaSolicitud.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.filePersoneria.setValidators([requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.tipoInstitucion.setValidators(null);
    }
    else if (this.perfil === this.textosCovid19.trabajadorIndependiente) {
      this.formData.controls.fileRutSol.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRutSolReverso.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAcreditacionResidencia.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileDeclaracionJuradaSimple.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.fileAnexoContrato.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileCertificadoTrabajadorIndependiente.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRegistroSocialHogares.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileActivacionSeguroCesantia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileImposibilidadPago.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileSituacionVulnerabilidad.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileFiniquitoCartaDespido.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileExposicionFundadaSolicitud.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.filePersoneria.setValidators([requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.tipoInstitucion.setValidators(null);
    }
    else if (this.perfil === this.textosCovid19.institucionesOrganizaciones) {
      this.formData.controls.tipoInstitucion.setValidators([Validators.required]);
      this.formData.controls.fileRutSol.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRutSolReverso.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.filePersoneria.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.fileAcreditacionResidencia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAnexoContrato.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileCertificadoTrabajadorIndependiente.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRegistroSocialHogares.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileActivacionSeguroCesantia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileImposibilidadPago.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileSituacionVulnerabilidad.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileFiniquitoCartaDespido.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileDeclaracionJuradaSimple.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileExposicionFundadaSolicitud.setValidators([requiredFileType(ValidatorService.fileTypes)]);
    }
    else if (this.perfil === this.textosCovid19.otros) {
      this.formData.controls.fileRutSol.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRutSolReverso.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAcreditacionResidencia.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileDeclaracionJuradaSimple.setValidators([Validators.required, requiredFileType(ValidatorService.fileTypes)]);

      //this.formData.controls.fileImposibilidadPago.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileExposicionFundadaSolicitud.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileRegistroSocialHogares.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileSituacionVulnerabilidad.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileActivacionSeguroCesantia.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileAnexoContrato.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      //this.formData.controls.fileCertificadoTrabajadorIndependiente.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.fileFiniquitoCartaDespido.setValidators([requiredFileType(ValidatorService.fileTypes)]);
      this.formData.controls.filePersoneria.setValidators([requiredFileType(ValidatorService.fileTypes)]);

      this.formData.controls.tipoInstitucion.setValidators(null);
    }

    this.formData.controls.tipoInstitucion.updateValueAndValidity();

    this.formData.controls.fileRutSol.updateValueAndValidity();
    this.formData.controls.fileRutSolReverso.updateValueAndValidity();
    this.formData.controls.fileRegistroSocialHogares.updateValueAndValidity();
    this.formData.controls.fileAcreditacionResidencia.updateValueAndValidity();
    this.formData.controls.fileActivacionSeguroCesantia.updateValueAndValidity();
    this.formData.controls.fileAnexoContrato.updateValueAndValidity();
    //this.formData.controls.fileCertificadoTrabajadorIndependiente.updateValueAndValidity();
    //this.formData.controls.fileImposibilidadPago.updateValueAndValidity();
    //this.formData.controls.fileSituacionVulnerabilidad.updateValueAndValidity();
    this.formData.controls.fileDeclaracionJuradaSimple.updateValueAndValidity();
    this.formData.controls.fileExposicionFundadaSolicitud.updateValueAndValidity();
    this.formData.controls.fileFiniquitoCartaDespido.updateValueAndValidity();
    this.formData.controls.filePersoneria.updateValueAndValidity();
  }
}
